export const ATTR_COLOR = {
  // 长期负荷
  '6WeekAvgTL': '#aadb37',
  '6WeekAvgTL-plan': 'rgba(170,219,55,0.25)',
  // 短期负荷
  '7DayAvgTL': '#3070ff',
  '7DayAvgTL-plan': 'rgba(49,112,255,0.25)',
  // 负荷差值
  tiredRateNew: '#ff8602',
  'tiredRateNew-plan': 'rgba(255,158,15,0.25)',

  // 训练负荷
  trainingLoad: '#00B3FF',
  'trainingLoad-plan': 'rgba(0, 179, 255, 0.25)',
  'trainingLoad-overflow': '#0081FF',
  // 运动时间
  duration: '#00B3FF',
  'duration-plan': 'rgba(0, 179, 255, 0.25)',
  'duration-overflow': '#0081FF',
  // 运动距离
  distance: '#00B3FF',
  'distance-plan': 'rgba(0, 179, 255, 0.25)',
  'distance-overflow': '#0081FF'
};
export const ATTR_PATH_COLOR = [
  {
    attr: {
      x1: '0%',
      y1: '0%',
      x2: '0%',
      y2: '100%'
    },
    datas: [
      { offset: '0%', color: 'rgb(25,179,255,0.6)' },
      { offset: '100%', color: 'rgba(25, 179, 255, 0)' }
    ],
    id: '6WeekAvgTL'
  },
  {
    attr: {
      x1: '0%',
      y1: '0%',
      x2: '0%',
      y2: '100%'
    },
    datas: [
      { offset: '0%', color: 'rgba(11, 231, 201, 0.8)' },
      { offset: '100%', color: 'rgba(11, 231, 201, 0)' }
    ],
    id: '7DayAvgTL'
  },
  {
    attr: {
      x1: '0%',
      y1: '0%',
      x2: '0%',
      y2: '100%'
    },
    datas: [
      { offset: '0%', color: 'rgba(255, 134, 2, 0.8)' },
      { offset: '100%', color: 'rgba(255, 197, 134, 0)' }
    ],
    id: 'tiredRateNew'
  }
];

export const LABEL_TYPE = {
  1: {
    value: 1,
    text: 'R5002'
    // icon: require('@/static/img/schedule/label-other.svg')
  },
  2: {
    value: 2,
    text: 'R5003'
    // icon: require('@/static/img/schedule/label-race.svg')
  },
  3: {
    value: 3,
    text: 'R5004'
    // icon: require('@/static/img/schedule/label-test.svg')
  }
};
